<!-- The hero is full-bleed: the photograph IS the banner, edge to edge, with no
     frame, no rounding and no side inset — the 2021 build's treatment.
     `app-banner-image` already owns that geometry (100vw, escaped from the
     container, with an `app-container` back inside it so the COPY stays on the
     page's own grid), so the panel is that component rather than a hand-rolled
     one.

     The picture is light and its subject sits right of centre, so the type
     sits ON it in the palette's ink rather than being knocked out of it, and
     the only help it needs is `paper-left`: a lift over the left of the frame,
     released before it reaches the notebook. The weight of that lift is
     measured rather than guessed — see the component. -->
<app-banner-image
  bannerClasses="hero-banner"
  [bannerImageUrl]="brand.heroImage"
  bannerScrim="paper-left"
  bannerSize="cover"
  bannerPosition="center"
>
  <div class="row align-items-center g-8 g-lg-10 w-100 hero-row">
    <div class="col-12 col-lg-7 text-center text-lg-start">
      <span class="eyebrow mb-6">
        <span class="dot"></span>{{ brand.name }}
        @if (demo.enabled) {
        · {{ "LANDING_PAGE.BANNER_VISION.LINE_6" | translate }}
        }
      </span>

      <!-- The last line is the actual claim — the other two are setup — so it
           is the one carrying the mark. -->
      <h1 class="hero-title fw-bold mb-6">
        <span class="d-block">{{ "LANDING_PAGE.BANNER_VISION.LINE_1" | translate }}</span>
        <span class="d-block">{{ "LANDING_PAGE.BANNER_VISION.LINE_2" | translate }}</span>
        <span class="d-block"
          ><span class="mark-spark">{{ "LANDING_PAGE.BANNER_VISION.LINE_3" | translate }}</span></span
        >
      </h1>

      <p class="hero-lead mb-3">{{ "LANDING_PAGE.BANNER_VISION.LINE_4" | translate }}</p>
      <p class="hero-lead mb-8">{{ "LANDING_PAGE.BANNER_VISION.LINE_5" | translate }}</p>

      <div class="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
        <!-- One primary on the page. The second route out is quiet on
             purpose: a visitor who is not ready to browse the catalogue wants
             to know what is in the thing, not to be asked twice. -->
        <span class="pulse-cta">
          <a
            class="btn btn-primary btn-lg rounded-pill px-8 fs-4"
            routerLink="/courses"
            data-testid="banner-cta"
          >
            {{ "LANDING_PAGE.ADVICE_BUTTON" | translate }}
          </a>
        </span>
        <a class="btn btn-hero-ghost btn-lg rounded-pill px-8 fs-4" href="#why-wise">
          {{ "LANDING_PAGE.WHY_WISE" | translate }}
        </a>
      </div>

      <!-- What is actually inside, named. Not counts: invented numbers on a
           demo are the fastest way to make the whole page untrustworthy. -->
      <ul class="hero-marks list-unstyled mt-10 mb-0">
        <li><span class="tick" style="background: var(--spark-amber)"></span>{{ "LANDING_PAGE.MARKS.VIDEO" | translate }}</li>
        <li><span class="tick" style="background: var(--spark-mint)"></span>{{ "LANDING_PAGE.MARKS.QUIZ" | translate }}</li>
        <li><span class="tick" style="background: var(--spark-sky)"></span>{{ "LANDING_PAGE.MARKS.REPORT" | translate }}</li>
      </ul>
    </div>
  </div>
</app-banner-image>
